import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonsModule } from '../button/button.module';
import { IconModule } from '../icon/icon.module';
import { AxisTimePickerComponent } from './axis-timepicker.component';
import { TimepickerInnerComponent } from './timepicker-inner.component';
import { TimepickerTemplateComponent } from './timepicker-template';
import { TimepickerComponent } from './timepicker.component';
import { TimepickerConfig } from './timepicker.config';
import { TimepickerService } from './timepicker.shared.service';

@NgModule({
  imports: [CommonModule, IconModule, FormsModule, ButtonsModule],
  declarations: [
    TimepickerComponent,
    TimepickerInnerComponent,
    AxisTimePickerComponent,
    TimepickerTemplateComponent
  ],
  providers: [TimepickerConfig, TimepickerService],
  entryComponents: [TimepickerComponent, TimepickerTemplateComponent],
  exports: [
    TimepickerComponent,
    TimepickerInnerComponent,
    AxisTimePickerComponent,
    TimepickerTemplateComponent
  ]
})
export class TimepickerModule {}
